import { render, staticRenderFns } from "./unionMembers.vue?vue&type=template&id=72231e10&"
import script from "./unionMembers.vue?vue&type=script&lang=js&"
export * from "./unionMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "unionMembers.vue"
export default component.exports